@if (bookingItem$ | async; as bookingItem) {
  <div>
    <ub-card [rounded]="true">
      <h1 title><span i18n>Preview of {{ bookingItem.doc.name }}</span></h1>
    </ub-card>
    <mat-card appearance="outlined">
      <div i18n>Pick an option</div>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="optionPicker">
          @for (option of bookingOptions; track option) {
            <mat-option [value]="option">{{ option.title ?? getDefaultOptionTitle() }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card>
    @if (rolePicker) {
      <mat-card appearance="outlined">
        <div i18n>State is {{ state.name }}. Pick role</div>
        <mat-form-field appearance="outline">
          <mat-select [formControl]="rolePicker">
            @for (option of roles; track option) {
              <mat-option [value]="option">{{ option }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card>
    }
    <mat-card appearance="outlined">
      @if (form$ | async; as form) {
        <form [formGroup]="form.group.control">
          <div class="form-container">
            <eas-easform-group [easGroup]="form.group"></eas-easform-group>
          </div>
          @for (trans of form.transitions; track trans) {
            <button mat-flat-button color="primary" type="button"
            (click)="doTransition(trans)">{{ trans.name }}</button>
          }
          @if (debug) {
            <div>
              <pre>{{ form.group.control.value | json }}</pre>
              <pre>{{ form.group.getValue() | json }}</pre>
            </div>
          }
        </form>
      } @else {
        @if (!optionPicker.value || !rolePicker.value) {
          <div i18n>Pick an option or role...</div>
        }
        @if (optionPicker.value && rolePicker.value  && !error) {
          <div i18n>Loading ...</div>
        }
        @if (optionPicker.value && rolePicker.value && error) {
          <div>{{ error }}</div>
        }
      }
    </mat-card>
    @if (debug) {
      <mat-card appearance="outlined">
        <pre>{{ model | json }}</pre>
        <pre>{{ state | json }}</pre>
      </mat-card>
    }
  </div>
}
